// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


// Copyright 2018 Ping Identity
//
// Licensed under the MIT License (the "License"); you may not use this file
// except in compliance with the License.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * Modified by:balajik
 * Purpose: Added client secret
 */
import { AuthorizationConfig, GeneralEnvironmentInfo, ApiResourceInfo } from '../app/comman/authorization_config';

export const environment: AuthorizationConfig & GeneralEnvironmentInfo & ApiResourceInfo  = {
  production: false, 
  issuer_uri: 'https://sso-uat.ibo.org',
  client_id:'https://ibo-ane-uat-rx-01-as.azurewebsites.net',
  client_secret:'HTOUID9wwaQNYrJ0szc25SMSi4q7cOrVCObYMXodePlqX2LW8kchdPshx6ulHJDX',
  redirect_uri: 'https://insights-qa.ibo.org/callback',
  authorization_endpoint: 'https://sso-uat.ibo.org/as/authorization.oauth2',
  token_endpoint: 'https://sso-uat.ibo.org/as/token.oauth2',
  user_info_endpoint: 'https://sso-uat.ibo.org/idp/userinfo.openid',

  extras: {
  //  'prompt': 'none',//'consent',//   to remove the consent window
   // 'access_type': 'offline'       // enable it later to access the application offline
  },

  apiUrl:'https://ibo-ane-uat-rx-01-as.azurewebsites.net/api', 
  //apiUrl:'https://localhost:44326/api',
  userTypeDomain:"intbacuat.onmicrosoft.com",
  myIBUrl:"https://ibo--uat.sandbox.my.site.com/ibportal/IBPortalLogin?lang=en_US",
  ibConnectUrl:"https://connect.ibo.org",
   instrumentationKey:'c3dd5fb8-0ffc-488a-bf9c-24af3505c286'
};
